import { inject, injectable } from "tsyringe";
import { ExtensionContext } from "../common/models/extension-config";
import { Module } from "../common/module";
import { ApiModule } from "./common/api/api.module";
import { ToolbarVersion } from "./common/api/autogenerated";
import { DashboardTooltipButtonManagerModule, UrlData } from "./common/dashboard-tooltip-button-manager.module";
import * as html2canvas from 'html2canvas';
import jsPDF from "jspdf";

@injectable()
export class ExportPdfModule extends Module {
    public name: string = 'ExportPdfModule';
    public acceptedLicenseFlags: string[] = ['Experimental_ExportToPdf'];
    public shouldRun(context: ExtensionContext): boolean { return context === ExtensionContext.vizql; }
    constructor(@inject(ApiModule) private api: ApiModule,
        @inject(DashboardTooltipButtonManagerModule) private dashboardTooltipButtonManager: DashboardTooltipButtonManagerModule) {
        super([api, dashboardTooltipButtonManager]);
    }
    private static pdfOpts = {
        margin: 0,
        fileName: 'dashboard.pdf',
        image: { type: 'png', quality: 1 },

        html2canvas: {
            scale: 1,
            width: 1000,
            height: 1000,
            allowTaint: true
            // foreignObjectRendering: true,
        },
        jsPDF: {
            unit: 'px',
            format: [1000, 1000],
            hotfixes: ['px_scaling'],
            orientation: 'portrait'
        },
        pagebreak: {
            mode: ['avoid-all']
        }
    }
    private get pdfOptions() { return ExportPdfModule.pdfOpts; }
    public async run(): Promise<void> {

        this.dashboardTooltipButtonManager.registerButtonFn(async (urlData: UrlData, version: ToolbarVersion) => {
            const api = await this.api.htmlRequest(c => c.apiTableauIntegrationPdfExportButtonHtml(false, version));
            if (api.success) {
                const el = api.value! as HTMLDivElement;
                el.onclick = this.btnClick;
                el.querySelector('#el-export-to-pdf-img')!.innerHTML = this.dashboardTooltipButtonManager.loadingSnippet;
                return api.value!;
            } else {
                console.error('Failed to get Export PDF button HTML', api.error);
                return undefined;
            }
        });



    }

    private btnClick() {

        const btn = <any>this;

        btn.querySelector('#el-export-to-pdf-icon')!.style.display = 'none';
        btn.querySelector('#el-export-to-pdf-img')!.style.display = 'inline-block';

        this.export().then(() => {
            btn.querySelector('#el-export-to-pdf-icon')!.style.display = 'inline-block';
            btn.querySelector('#el-export-to-pdf-img')!.style.display = 'none';
        });


       

    }

    public async export() {
        console.log('Exporting PDF...');
        const content = document.body.querySelector('#dashboard-spacer') ?? document.body.querySelector('#main-content')!;
        // const opts = ExportPdfModule.pdfOpts;
        // if (opts.jsPDF.format[0] === 1000 && opts.jsPDF.format[1] === 1000) {
        //     opts.jsPDF.unit = 'pt';
        //     opts.jsPDF.format = [content.scrollHeight, content.scrollWidth];
        //     opts.jsPDF.orientation = content.scrollWidth > content.scrollHeight ? 'landscape' : 'portrait';
        // }
        // opts.html2canvas.width = content.scrollWidth;
        // opts.html2canvas.height = content.scrollHeight;
        // console.log(content, opts);
        console.log("Size: ", content.scrollHeight, content.clientHeight);
        html2canvas.default(content as HTMLElement, {
            allowTaint: true,
            backgroundColor: undefined,
            imageTimeout: 10000,
            useCORS: true,
            height: content.scrollHeight,
            width: content.scrollWidth,
            scale: 1,
            scrollX: 0,
            scrollY: 0,
            windowHeight: window.outerHeight,
            windowWidth: window.outerWidth,
            x: 0,
            y: 0,
            onclone: (doc, el) => {
                const style = doc.createElement('script');
                style.appendChild(document.createTextNode("* { letter-spacing: '0px'; }"));
                doc.head.appendChild(style);
            }
            
        }).then(e => {
            const doc = new jsPDF(content.scrollWidth > content.scrollHeight ? "l": "p", "px", [content.scrollHeight, content.scrollWidth]);
            
            doc.addImage(e.toDataURL('image/png'), "PNG", 0, 0, content.scrollWidth, content.scrollHeight);

            doc.save("dashboard.pdf");
            console.log('PDF exported');
        }).catch(e => {
            console.error('Failed to generate image', e);
        });

        // const doc = new jsPDF();
        // try {
        //     await new Promise<void>((resolve, reject) => {
        //         doc.html(content as HTMLElement, {
        //             callback: doc => {
        //                 doc.save('dashboard.pdf');
        //                 resolve();
        //             },
        //             margin: [0,0,0,0],
        //             autoPaging: 'slice',
        //             x: 0,
        //             y: 0,
        //             width: content.scrollWidth,
        //             windowWidth: window.innerWidth,
        //             image: {
        //                 quality: 1,
        //                 type: 'png'
        //             },
        //             html2canvas: {
        //                 allowTaint: true
        //             }
        //         })
        //     });
        //     console.log('PDF generation success');
        // } catch (e) {
        //     console.error('PDF generation failed', e);
        // }
    }

}